/* KK21 cart drawer extras (AB test)
 * - "YOUR ORDER IS RESERVED FOR" countdown: always restarts at 9:00
 *   every time the drawer opens (per design spec).
 * - Special offer cards: add the offer variant as a NEW cart line and
 *   re-render the drawer via Shopify section rendering.
 */
(function () {
  var RESERVE_SECONDS = 9 * 60;
  var deadline = null;

  function renderReserveTimer() {
    var el = document.querySelector('[data-kk21-reserve]');
    if (!el || deadline === null) return;
    var remaining = Math.max(0, Math.round((deadline - Date.now()) / 1000));
    var m = Math.floor(remaining / 60);
    var s = remaining % 60;
    el.textContent = m + ':' + (s < 10 ? '0' : '') + s;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    // Restart the reserve countdown each time the drawer opens.
    var wasActive = drawer.classList.contains('active');
    new MutationObserver(function () {
      var isActive = drawer.classList.contains('active');
      if (isActive && !wasActive) {
        deadline = Date.now() + RESERVE_SECONDS * 1000;
        renderReserveTimer();
      }
      wasActive = isActive;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });

    setInterval(renderReserveTimer, 500);

    // Offer cards: add as a new line, then re-render the drawer.
    document.addEventListener('click', function (event) {
      var btn = event.target.closest('.kk21-offer-add');
      if (!btn || btn.classList.contains('loading')) return;

      btn.classList.add('loading');

      var body = new FormData();
      body.append('id', btn.dataset.variantId);
      body.append('quantity', '1');
      // Campaign order tag, same attribute the product form sets (KK21 CONFIG
      // in kk21-cart-offers.liquid)
      if (btn.dataset.campaign) {
        body.append('attributes[_campaign]', btn.dataset.campaign);
      }
      body.append(
        'sections',
        drawer.getSectionsToRender().map(function (section) {
          return section.id;
        })
      );
      body.append('sections_url', window.location.pathname);

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: body,
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          if (response.status) {
            console.error('KK21 offer add failed:', response.description || response.message);
            return;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'kk21-offer',
              productVariantId: btn.dataset.variantId,
              cartData: response,
            });
          }
          drawer.renderContents(response);
        })
        .catch(function (error) {
          console.error('KK21 offer add failed:', error);
        })
        .finally(function () {
          var freshBtn = document.querySelector('.kk21-offer-add[data-variant-id="' + btn.dataset.variantId + '"]');
          if (freshBtn) freshBtn.classList.remove('loading');
          btn.classList.remove('loading');
        });
    });
  });
})();
